import React from "react";

const SkeletonSelect = () => {
  return (
    <div className="skeleton-select">
      <div className="skeleton-select-placeholder" />
    </div>
  );
};

export default SkeletonSelect;
